module.exports = __webpack_public_path__ + "img/Download Icon (1).ad7643dc.svg";